import { render, staticRenderFns } from "./commonQuestion.vue?vue&type=template&id=7e205dd6"
import script from "./commonQuestion.vue?vue&type=script&lang=js"
export * from "./commonQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports